import { useContext } from 'react';
import SeoProjectContext from '@/contexts/seoProjectContext';

const useSeoProject = () => useContext(SeoProjectContext);

export default useSeoProject;
